const FileUploaderModel = function() {
  this.parentDivClass = null;
  this.parentDivStyle = null;
  this.photoCloseStyle = null;
  this.imageStyle = null;
  this.uploadDivStyle = null;
  this.fileName = null;
};
export default FileUploaderModel;
